import { AddressPipe } from './address.pipe';
import { DisplayNamePipe } from './display-name.pipe';
import { ExtendedDatePipe } from './extended-date.pipe';
import { DisplayNameMultilinePipe } from './display-name-multiline.pipe';
import { ArticleNamePipe } from './article-name.pipe';
import { DetailedDisplayNamePipe } from './detailed-display-name.pipe';
import { TimeUnitPipe } from './time-unit.pipe';

export const PIPES = [AddressPipe, DisplayNamePipe, DetailedDisplayNamePipe, ExtendedDatePipe, DisplayNameMultilinePipe, ArticleNamePipe, TimeUnitPipe];
